import clsx from "clsx";

interface Props {
  type?: "button" | "submit";
  color?: "gray" | "light-gray" | "primary";
  children: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

const ButtonSmall = ({
  type = "button",
  color = "gray",
  children,
  onClick,
  className,
  disabled,
}: Props) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={clsx(
        "inline-flex items-center justify-center rounded-md h-9 text-14 duration-300 disabled:cursor-not-allowed",
        {
          "bg-secondary text-white": color === "gray",
          "border bg-primary text-white": color === "primary",
          "bg-gray text-secondary font-bold !text-16": color === "light-gray",
        },
        className,
      )}
    >
      {children}
    </button>
  );
};

export default ButtonSmall;
